import Vue from 'vue'
import App from './app.vue'
import Global from '../../../components/lovesway/Global'

var remSize = Global.setPhoneRem()
document.documentElement.style.fontSize = remSize

new Vue({
  el: '#app',
  render: h => h(App)
})
